// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { DecideActionData, DecideActionErrors, DecideActionResponses, EndViewAsData, EndViewAsErrors, EndViewAsResponses, GetCustomerData, GetCustomerErrors, GetCustomerResponses, GetDashboardData, GetDashboardErrors, GetDashboardResponses, GetPaymentTimelineData, GetPaymentTimelineErrors, GetPaymentTimelineResponses, GetStaffMeData, GetStaffMeErrors, GetStaffMeResponses, GetUserData, GetUserErrors, GetUserResponses, IssueViewAsTokenData, IssueViewAsTokenErrors, IssueViewAsTokenResponses, ListActionsData, ListActionsErrors, ListActionsResponses, ListActionTypesData, ListActionTypesErrors, ListActionTypesResponses, ListAllPaymentsData, ListAllPaymentsErrors, ListAllPaymentsResponses, ListBreaksData, ListBreaksErrors, ListBreaksResponses, ListOnboardingQueueData, ListOnboardingQueueErrors, ListOnboardingQueueResponses, ListPartnerEventsData, ListPartnerEventsErrors, ListPartnerEventsResponses, ListPartnersData, ListPartnersErrors, ListPartnersResponses, ListReconRunsData, ListReconRunsErrors, ListReconRunsResponses, ListStaffData, ListStaffErrors, ListStaffResponses, ListViewAsData, ListViewAsErrors, ListViewAsResponses, ProvisionStaffData, ProvisionStaffErrors, ProvisionStaffResponses, RequestActionData, RequestActionErrors, RequestActionResponses, ResolveBreakData, ResolveBreakErrors, ResolveBreakResponses, RunReconData, RunReconErrors, RunReconResponses, SearchAuditData, SearchAuditErrors, SearchAuditResponses, SearchOrgsData, SearchOrgsErrors, SearchOrgsResponses, SearchUsersData, SearchUsersErrors, SearchUsersResponses, SetPartnerOverrideData, SetPartnerOverrideErrors, SetPartnerOverrideResponses, SetStaffRolesData, SetStaffRolesErrors, SetStaffRolesResponses, SetStaffStatusData, SetStaffStatusErrors, SetStaffStatusResponses, StartViewAsData, StartViewAsErrors, StartViewAsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const getStaffMe = <ThrowOnError extends boolean = false>(options?: Options<GetStaffMeData, ThrowOnError>): RequestResult<GetStaffMeResponses, GetStaffMeErrors, ThrowOnError> => (options?.client ?? client).get<GetStaffMeResponses, GetStaffMeErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/me',
    ...options
});

export const getDashboard = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardData, ThrowOnError>): RequestResult<GetDashboardResponses, GetDashboardErrors, ThrowOnError> => (options?.client ?? client).get<GetDashboardResponses, GetDashboardErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/dashboard',
    ...options
});

export const listStaff = <ThrowOnError extends boolean = false>(options?: Options<ListStaffData, ThrowOnError>): RequestResult<ListStaffResponses, ListStaffErrors, ThrowOnError> => (options?.client ?? client).get<ListStaffResponses, ListStaffErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/staff',
    ...options
});

/**
 * Creates a staff identity and emails them a one-time setup link.
 */
export const provisionStaff = <ThrowOnError extends boolean = false>(options: Options<ProvisionStaffData, ThrowOnError>): RequestResult<ProvisionStaffResponses, ProvisionStaffErrors, ThrowOnError> => (options.client ?? client).post<ProvisionStaffResponses, ProvisionStaffErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/staff',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setStaffRoles = <ThrowOnError extends boolean = false>(options: Options<SetStaffRolesData, ThrowOnError>): RequestResult<SetStaffRolesResponses, SetStaffRolesErrors, ThrowOnError> => (options.client ?? client).put<SetStaffRolesResponses, SetStaffRolesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/staff/{staffId}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setStaffStatus = <ThrowOnError extends boolean = false>(options: Options<SetStaffStatusData, ThrowOnError>): RequestResult<SetStaffStatusResponses, SetStaffStatusErrors, ThrowOnError> => (options.client ?? client).put<SetStaffStatusResponses, SetStaffStatusErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/staff/{staffId}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const searchOrgs = <ThrowOnError extends boolean = false>(options?: Options<SearchOrgsData, ThrowOnError>): RequestResult<SearchOrgsResponses, SearchOrgsErrors, ThrowOnError> => (options?.client ?? client).get<SearchOrgsResponses, SearchOrgsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/orgs',
    ...options
});

/**
 * Customer 360. Viewing is audited.
 */
export const getCustomer = <ThrowOnError extends boolean = false>(options: Options<GetCustomerData, ThrowOnError>): RequestResult<GetCustomerResponses, GetCustomerErrors, ThrowOnError> => (options.client ?? client).get<GetCustomerResponses, GetCustomerErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/orgs/{orgId}',
    ...options
});

export const searchUsers = <ThrowOnError extends boolean = false>(options: Options<SearchUsersData, ThrowOnError>): RequestResult<SearchUsersResponses, SearchUsersErrors, ThrowOnError> => (options.client ?? client).get<SearchUsersResponses, SearchUsersErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/users',
    ...options
});

export const getUser = <ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>): RequestResult<GetUserResponses, GetUserErrors, ThrowOnError> => (options.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/users/{userId}',
    ...options
});

export const listAllPayments = <ThrowOnError extends boolean = false>(options?: Options<ListAllPaymentsData, ThrowOnError>): RequestResult<ListAllPaymentsResponses, ListAllPaymentsErrors, ThrowOnError> => (options?.client ?? client).get<ListAllPaymentsResponses, ListAllPaymentsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/payments',
    ...options
});

export const getPaymentTimeline = <ThrowOnError extends boolean = false>(options: Options<GetPaymentTimelineData, ThrowOnError>): RequestResult<GetPaymentTimelineResponses, GetPaymentTimelineErrors, ThrowOnError> => (options.client ?? client).get<GetPaymentTimelineResponses, GetPaymentTimelineErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/payments/{paymentId}',
    ...options
});

export const listOnboardingQueue = <ThrowOnError extends boolean = false>(options?: Options<ListOnboardingQueueData, ThrowOnError>): RequestResult<ListOnboardingQueueResponses, ListOnboardingQueueErrors, ThrowOnError> => (options?.client ?? client).get<ListOnboardingQueueResponses, ListOnboardingQueueErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/onboarding',
    ...options
});

export const listActionTypes = <ThrowOnError extends boolean = false>(options?: Options<ListActionTypesData, ThrowOnError>): RequestResult<ListActionTypesResponses, ListActionTypesErrors, ThrowOnError> => (options?.client ?? client).get<ListActionTypesResponses, ListActionTypesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/action-types',
    ...options
});

export const listActions = <ThrowOnError extends boolean = false>(options?: Options<ListActionsData, ThrowOnError>): RequestResult<ListActionsResponses, ListActionsErrors, ThrowOnError> => (options?.client ?? client).get<ListActionsResponses, ListActionsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/actions',
    ...options
});

/**
 * Requests an act-on-behalf change with a reason. Changes that loosen a control wait
 * for a second staff member's approval; the rest run immediately.
 *
 */
export const requestAction = <ThrowOnError extends boolean = false>(options: Options<RequestActionData, ThrowOnError>): RequestResult<RequestActionResponses, RequestActionErrors, ThrowOnError> => (options.client ?? client).post<RequestActionResponses, RequestActionErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/actions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const decideAction = <ThrowOnError extends boolean = false>(options: Options<DecideActionData, ThrowOnError>): RequestResult<DecideActionResponses, DecideActionErrors, ThrowOnError> => (options.client ?? client).post<DecideActionResponses, DecideActionErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/actions/{actionId}/decision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listViewAs = <ThrowOnError extends boolean = false>(options?: Options<ListViewAsData, ThrowOnError>): RequestResult<ListViewAsResponses, ListViewAsErrors, ThrowOnError> => (options?.client ?? client).get<ListViewAsResponses, ListViewAsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/view-as',
    ...options
});

/**
 * Opens a read-only, time-boxed view-as session. Write access is requested as the impersonation.write action.
 */
export const startViewAs = <ThrowOnError extends boolean = false>(options: Options<StartViewAsData, ThrowOnError>): RequestResult<StartViewAsResponses, StartViewAsErrors, ThrowOnError> => (options.client ?? client).post<StartViewAsResponses, StartViewAsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/view-as',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const endViewAs = <ThrowOnError extends boolean = false>(options: Options<EndViewAsData, ThrowOnError>): RequestResult<EndViewAsResponses, EndViewAsErrors, ThrowOnError> => (options.client ?? client).delete<EndViewAsResponses, EndViewAsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/view-as/{sessionId}',
    ...options
});

/**
 * Reissues the link for an active session the caller owns.
 */
export const issueViewAsToken = <ThrowOnError extends boolean = false>(options: Options<IssueViewAsTokenData, ThrowOnError>): RequestResult<IssueViewAsTokenResponses, IssueViewAsTokenErrors, ThrowOnError> => (options.client ?? client).post<IssueViewAsTokenResponses, IssueViewAsTokenErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/view-as/{sessionId}/token',
    ...options
});

export const listBreaks = <ThrowOnError extends boolean = false>(options?: Options<ListBreaksData, ThrowOnError>): RequestResult<ListBreaksResponses, ListBreaksErrors, ThrowOnError> => (options?.client ?? client).get<ListBreaksResponses, ListBreaksErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/recon/breaks',
    ...options
});

export const resolveBreak = <ThrowOnError extends boolean = false>(options: Options<ResolveBreakData, ThrowOnError>): RequestResult<ResolveBreakResponses, ResolveBreakErrors, ThrowOnError> => (options.client ?? client).post<ResolveBreakResponses, ResolveBreakErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/recon/breaks/{breakId}/resolution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listReconRuns = <ThrowOnError extends boolean = false>(options?: Options<ListReconRunsData, ThrowOnError>): RequestResult<ListReconRunsResponses, ListReconRunsErrors, ThrowOnError> => (options?.client ?? client).get<ListReconRunsResponses, ListReconRunsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/recon/runs',
    ...options
});

export const runRecon = <ThrowOnError extends boolean = false>(options?: Options<RunReconData, ThrowOnError>): RequestResult<RunReconResponses, RunReconErrors, ThrowOnError> => (options?.client ?? client).post<RunReconResponses, RunReconErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/recon/runs',
    ...options
});

export const listPartners = <ThrowOnError extends boolean = false>(options?: Options<ListPartnersData, ThrowOnError>): RequestResult<ListPartnersResponses, ListPartnersErrors, ThrowOnError> => (options?.client ?? client).get<ListPartnersResponses, ListPartnersErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/partners',
    ...options
});

/**
 * Forces a partner's circuit up or down (or clears the override with an empty state).
 */
export const setPartnerOverride = <ThrowOnError extends boolean = false>(options: Options<SetPartnerOverrideData, ThrowOnError>): RequestResult<SetPartnerOverrideResponses, SetPartnerOverrideErrors, ThrowOnError> => (options.client ?? client).put<SetPartnerOverrideResponses, SetPartnerOverrideErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/partners/{partner}/override',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listPartnerEvents = <ThrowOnError extends boolean = false>(options?: Options<ListPartnerEventsData, ThrowOnError>): RequestResult<ListPartnerEventsResponses, ListPartnerEventsErrors, ThrowOnError> => (options?.client ?? client).get<ListPartnerEventsResponses, ListPartnerEventsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/partner-events',
    ...options
});

export const searchAudit = <ThrowOnError extends boolean = false>(options?: Options<SearchAuditData, ThrowOnError>): RequestResult<SearchAuditResponses, SearchAuditErrors, ThrowOnError> => (options?.client ?? client).get<SearchAuditResponses, SearchAuditErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'payezy_staff_session',
            type: 'apiKey'
        }],
    url: '/admin/v1/audit',
    ...options
});
